import React, { ReactNode } from "react";
import { StyledChip } from "./Chip.styled";
import { BodyTyp } from "../../Typography/Typography";
import { FontWeightEnum } from "../../../types/AppTypes";
import { theme } from "../../../constants/StyledComponents";

export enum ShapeEnum {
  CIRCLE = "circle",
  ROUND = "round",
}

export type ChipOption<T> = {
  value: T;
  label: string | ReactNode;
};

export enum ChipSizeEnum {
  BIG = "big",
  REGULAR = "regular",
  SMALL = "small",
  X_SMALL = "x_small",
}

type CustomChipsProps<T> = {
  option: ChipOption<T>;
  onSelectChip?: (value: T) => void;
  selectedChip?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  size?: ChipSizeEnum;
  shape?: ShapeEnum;
  fullWidth?: boolean;
  readonly?: boolean;
  hoverEffect?: boolean;
  borderWidth?: number;
  textColor?: string;
  hoverBackgroundColor?: string;
};

export const Chip = <T,>({
  option,
  onSelectChip,
  selectedChip,
  size,
  borderColor = theme.colors.purple,
  backgroundColor = theme.colors.white,
  shape = ShapeEnum.CIRCLE,
  fullWidth = false,
  readonly,
  hoverEffect = false,
  borderWidth = 1,
  textColor,
  hoverBackgroundColor,
}: CustomChipsProps<T>) => {
  return (
    <StyledChip
      $selected={selectedChip}
      onClick={() => (onSelectChip ? onSelectChip(option.value) : {})}
      $borderColor={borderColor}
      $backgroundColor={backgroundColor}
      $size={size}
      $shape={shape}
      $isString={typeof option.label === "string"}
      $fullWidth={fullWidth}
      $readonly={readonly}
      $hoverEffect={hoverEffect}
      $borderWidth={borderWidth}
      $textColor={textColor}
      $hoverBackgroundColor={hoverBackgroundColor}
    >
      {typeof option.label === "string" ? (
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="3">
          {option.label}
        </BodyTyp>
      ) : (
        option.label
      )}
    </StyledChip>
  );
};
